<div class="modal-header d-flex align-items-center justify-content-between">
  <h4 class="modal-title">Create Folder</h4>
  <button type="button" class="btn btn-link p-0 border-0" aria-label="Close" (click)="modal.dismiss()">
    <i class="bi bi-x-lg"></i>
  </button>
</div>
<div class="modal-body">
  <form [formGroup]="folderForm">
    <div class="mb-3">
      <label class="form-label">Parent Location</label>
      <p class="text-muted">
        <i class="bi bi-folder2-open me-2"></i>{{ getFullPath() }}
      </p>
    </div>
    <div class="mb-3">
      <label for="folderName" class="form-label">Folder Name</label>
      <input type="text"
        class="form-control"
        id="folderName"
        formControlName="name"
        placeholder="Enter folder name">
        <div class="form-text text-muted">
          Only letters, numbers, spaces and underscores allowed
        </div>
        @if (name?.invalid && (name?.dirty || name?.touched)) {
          <div class="text-danger mt-1">
            @if (name?.errors?.['required']) {
              <small>Folder name is required</small>
            }
            @if (name?.errors?.['pattern']) {
              <small>Only letters, numbers, spaces and underscores allowed</small>
            }
            @if (name?.errors?.['maxlength']) {
              <small>Name cannot exceed 50 characters</small>
            }
          </div>
        }
      </div>
    </form>
  </div>
  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="modal.dismiss()">Cancel</button>
    <button type="button"
      class="btn btn-primary"
      (click)="onSubmit()"
      [disabled]="!folderForm.valid">
      Create Folder
    </button>
  </div>